import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeLike, pointGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {WeldOperatorParameters} from "#template/nodes/geometry-graph/attribute/weld-operator/geometry-weld-operator-node"
import {GeometryWeldOperatorNode, weldOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/weld-operator/geometry-weld-operator-node"

export type PointGeometryWeldOperatorParameters = WeldOperatorParameters<PointGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<PointGeometryWeldOperatorParameters> = {
    nodeClass: "PointGeometryWeldOperator",
    validation: {
        parameters: weldOperatorParametersSchema(pointGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryWeldOperator extends GeometryWeldOperatorNode<0, PointGeometryAttributeLikeNode> implements PointGeometryAttributeLikeNode {
    get [pointGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
